/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Createdat1Inputs */

const en__field_createdat1 = /** @type {(inputs: _Field_Createdat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created at`)
};

/**
* | output |
* | --- |
* | "Created at" |
*
* @param {_Field_Createdat1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_createdat1 = /** @type {((inputs?: _Field_Createdat1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Createdat1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_createdat1(inputs)
});
export { _field_createdat1 as "_field_createdAt" }